'use client'
import React, {
  useEffect,
  useContext,
  createContext,
  useState,
  Dispatch,
  SetStateAction,
  useRef,
  MutableRefObject,
} from 'react'

type HeaderState = {
  isOpen: boolean
  isTransitioning: MutableRefObject<boolean>
}

const headerStateContext = createContext<
  [HeaderState, Dispatch<SetStateAction<HeaderState>>] | null
>(null)

export function HeaderStateProvider(props: { children: React.ReactNode }) {
  const { children } = props
  const isTransitioning = useRef(false)
  const [state, setState] = useState<HeaderState>(() => ({
    isOpen: false,
    isTransitioning,
  }))

  useEffect(() => {
    const quickSearchBtn = document.getElementById('quicksearch-open-btn')
    if (quickSearchBtn) {
      const close = () => setState((prev) => ({ ...prev, isOpen: false }))
      quickSearchBtn.addEventListener('click', close)
      return () => {
        quickSearchBtn.removeEventListener('click', close)
      }
    }
  }, [state])

  return (
    <headerStateContext.Provider value={[state, setState]}>{children}</headerStateContext.Provider>
  )
}

export function useHeaderState() {
  const maybeHeaderState = useContext(headerStateContext)

  if (!maybeHeaderState) {
    throw new Error()
  }

  return maybeHeaderState
}
